import React from 'react'
import { TextInput } from 'SRC/ui/FormElements'
import config from 'SRC/config/config.yaml'

const passwordField = {
  id: 'password',
  name: 'password',
  type: 'password',
  label: config.updateProfileForm.password.newPassword,
  isRequired: true
}

export const Password = () =>
  <TextInput {...passwordField} />
